module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point01_03_travel-6b3ee37fd8a86d4868ad7dc1b7ed3089.jpg";